export { MeetingDetailPage } from '@/components/pages/meeting/MeetingDetail';
